import React from "react";
import { useGlobalContext } from "../context";

const Gallery = () => {
  const { gallery } = useGlobalContext();

  return (
    <section className="gallery">
      <h2 className="gallery-header menu-header">Gallery</h2>
      <article className="gallery-list">
        {gallery.map((pics, index) => {
          return <img key={index} src={pics} alt="Past Event" />;
        })}
      </article>
    </section>
  );
};

export default Gallery;
